<template>
  <!-- fieldType 1:单行文本  2:多行文本 systemType 系统预设字段 默认最多输入200  -->
  <a-input
    v-if="data.fieldType === '1'"
    v-model:value="inputValue"
    :maxlength="maxlength"
    show-count
    :disabled="disabled"
    :placeholder="data.remind ? data.remind : $t('ep_admin_tips_input')"
    @input="handleInput"
    @blur="handleBlur"
  />
  <a-textarea
    v-if="data.fieldType === '2'"
    v-model:value="inputValue"
    :maxlength="data.characterLimit ? data.characterLimit : 1000"
    show-count
    :disabled="disabled"
    :placeholder="data.remind ? data.remind : $t('ep_admin_tips_input')"
    @input="handleInput"
    @blur="handleBlur"
  />
</template>
<script setup lang="ts">
import { ref, watch, computed } from 'vue'

const props = defineProps({
  data: {
    required: true,
    type: Object,
    default: {}
  },
  value: {
    required: true,
    type: String,
    default: ''
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:value', 'blur'])

const inputValue = ref(props.value)

const maxlength = computed(() => {
  if (props.data.characterLimit) return props.data.characterLimit
  if (props.data.systemType) return 200
  return 1000
})

const handleInput = () => {
  // 开启输入数字后限制只能输入数字且只有一个负号和一个小数点。其中负号只能在数字前，小数点只能在数字后。
  if (props.data.numberTypeFlag === '1') {
    inputValue.value = inputValue.value.replace(/[^0-9.-]|(?<=\..*)\.|(?<!\d)\.|(?!^)-/g, '')
  }
}

const handleBlur = (value: any) => {
  emit('update:value', value.target.value)
  emit('blur', value.target.value)
}

watch(
  () => props.data.fieldType,
  value => {
    inputValue.value = ''
  }
)
</script>
